import { DocumentArchivePortalSharedResourceConfig, PortalSharedResource, PortalSharedResourceType, PortalSharedResourceTypes } from '../../../DTOs';
import { basicValidation } from '../basicValidation';

export const portalSharedResourceFieldValidation = {
    portalSharedResource: {
        resourceType: (value: PortalSharedResourceType) => PortalSharedResourceTypes.includes(value),
        resourceId: (value: string) => basicValidation.isValidFileName(value, 128),
        config: (value: unknown) => isObject(value),
        configForType: (resourceType: PortalSharedResourceType, config: unknown) =>
        {
            if (resourceType === 'DocumentArchiveFile')
                return isDocumentArchiveConfig(config);

            return false;
        }
    }
};

function isObject(value: unknown): value is Record<string, unknown>
{
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function isDocumentArchiveConfig(value: unknown): value is PortalSharedResource['config']
{
    if (!isObject(value))
        return false;

    const keys = Object.keys(value);
    if (keys.length !== 1 || keys[0] !== 'note')
        return false;

    const config = value as DocumentArchivePortalSharedResourceConfig;
    return basicValidation.resourceText.isValid(config.note, true, 1000);
}
